/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Clothing_TypeInputs */

const en_field_clothing_type = /** @type {(inputs: Field_Clothing_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specific Type`)
};

const es_field_clothing_type = /** @type {(inputs: Field_Clothing_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo específico`)
};

const fr_field_clothing_type = /** @type {(inputs: Field_Clothing_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type spécifique`)
};

const de_field_clothing_type = /** @type {(inputs: Field_Clothing_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spezifischer Typ`)
};

const ja_field_clothing_type = /** @type {(inputs: Field_Clothing_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`具体的な種類`)
};

const zh_field_clothing_type = /** @type {(inputs: Field_Clothing_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`具体类型`)
};

const ar_field_clothing_type = /** @type {(inputs: Field_Clothing_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النوع المحدد`)
};

const id_field_clothing_type = /** @type {(inputs: Field_Clothing_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis Spesifik`)
};

const it_field_clothing_type = /** @type {(inputs: Field_Clothing_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo Specifico`)
};

const ru_field_clothing_type = /** @type {(inputs: Field_Clothing_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип одежды`)
};

const pt_field_clothing_type = /** @type {(inputs: Field_Clothing_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo Específico`)
};

const ko_field_clothing_type = /** @type {(inputs: Field_Clothing_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상세 유형`)
};

/**
* | output |
* | --- |
* | "Specific Type" |
*
* @param {Field_Clothing_TypeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_clothing_type = /** @type {((inputs?: Field_Clothing_TypeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Clothing_TypeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_clothing_type(inputs)
	if (locale === "es") return es_field_clothing_type(inputs)
	if (locale === "fr") return fr_field_clothing_type(inputs)
	if (locale === "de") return de_field_clothing_type(inputs)
	if (locale === "ja") return ja_field_clothing_type(inputs)
	if (locale === "zh") return zh_field_clothing_type(inputs)
	if (locale === "ar") return ar_field_clothing_type(inputs)
	if (locale === "id") return id_field_clothing_type(inputs)
	if (locale === "it") return it_field_clothing_type(inputs)
	if (locale === "ru") return ru_field_clothing_type(inputs)
	if (locale === "pt") return pt_field_clothing_type(inputs)
	return ko_field_clothing_type(inputs)
});